<template>
  <iModal
    :visible="invitePublicationModalOpen"
    title="Invite to Join Network"
    :max-width="600"
    @close="closeModal"
  >
    <template #body>
      <iColumn gap="large">
        <iColumn gap="none">
          <iAutoComplete
            v-model="selectedNetworkId"
            label="Which Network?"
            :items="ownedNetworks"
            placeholder="Search for a network"
            item-label-key="name"
            item-value-key="network_id"
            width="fill"
            show-initial-results-on-click
            @item-selected="handleNetworkSelected"
          />
          <iText v-if="validationErrors.network" variant="error">
            {{ validationErrors.network }}
          </iText>
        </iColumn>
        <iColumn gap="none">
          <iTextArea
            v-model="form.message"
            label="Invite Message"
            placeholder="Enter invitation message..."
            :rows="5"
            width="fill"
          />
          <iText v-if="validationErrors.message" variant="error">
            {{ validationErrors.message }}
          </iText>
        </iColumn>
        <iText v-if="error" variant="error">
          {{ error }}
        </iText>
      </iColumn>
    </template>
    <template #footer>
      <iRow align="right" gap="standard">
        <iColumn width="hug">
          <iButton variant="secondary" @click="closeModal">
            Cancel
          </iButton>
        </iColumn>
        <iColumn width="hug">
          <iButton
            variant="primary"
            loading-spinner-position="inside"
            :is-loading="isLoadingInvitePublication"
            @click="submit"
          >
            Send Invite
          </iButton>
        </iColumn>
      </iRow>
    </template>
  </iModal>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useNetworkStore } from "@/stores/network-store";
import { useGeneralStore } from "%/stores/general-store";

export default {
  name: "InvitePublicationModal",
  data() {
    return {
      form: {
        message: "",
      },
      selectedNetworkId: null,
      selectedNetwork: null,
      validationErrors: {
        network: "",
        message: "",
      },
    };
  },
  computed: {
    ...mapState(useNetworkStore, [
      "invitePublicationModalOpen",
      "isLoadingInvitePublication",
      "error",
      "ownedNetworks",
      "selectedInvitePublication",
    ]),
    ...mapState(useGeneralStore, ["orgId", "userId"]),
  },
  methods: {
    ...mapActions(useNetworkStore, [
      "invitePublication",
      "closeInvitePublicationModal",
    ]),
    closeModal() {
      this.closeInvitePublicationModal();
      this.form = { message: "" };
      this.selectedNetworkId = null;
      this.selectedNetwork = null;
      this.validationErrors.network = "";
      this.validationErrors.message = "";
    },
    handleNetworkSelected(network) {
      this.selectedNetwork = network || null;
      if (!network) {
        this.selectedNetworkId = null;
      }
    },
    submit() {
      this.validationErrors.network = "";
      this.validationErrors.message = "";

      if (!this.selectedNetwork) {
        this.validationErrors.network = "Please select a network";
      }

      if (!this.form.message) {
        this.validationErrors.message = "Invite message is required";
      }

      if (this.validationErrors.network || this.validationErrors.message) {
        return;
      }

      this.invitePublication(
        this.selectedNetwork.network_id,
        this.selectedInvitePublication,
        this.orgId,
        this.userId,
        this.selectedNetwork.owner_org_id,
        this.form.message,
        this.closeModal,
      );
    },
  },
};
</script>

<style scoped>
</style>
